var exports = {
  "k": "xa15a2ab7--42490a--container",
};

module.exports = exports;
